var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-listing", attrs: { id: "project__list" } },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-project",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editProjectModal",
            title: ""
          },
          on: {
            hide: _vm.editProjectModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [_c("EditProjectModal", { ref: "refEditProjectModal" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "viewTitleModal",
            title: "Enter View Title"
          }
        },
        [
          _c("ViewTitleModal", {
            ref: "refViewTitleModal",
            on: { setActiveView: _vm.setActiveView }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "viewTitleUpdateModal",
            title: "Enter View Title"
          }
        },
        [
          _c("ViewTitleModal", {
            ref: "refViewTitleModal",
            attrs: { title: _vm.viewBtnLabel, viewId: _vm.activeView },
            on: { setActiveView: _vm.setActiveView }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "headerViewSelectModal",
            "hide-footer": "",
            title: "Views"
          },
          on: { hidden: _vm.viewSelectModalHidden }
        },
        [
          _c(
            "div",
            {
              staticClass: "saved-views",
              attrs: { id: "header-view-select-modal" }
            },
            [
              _c(
                "div",
                { staticClass: "view-select-title-header" },
                [
                  _c("h4", [_vm._v("Views")]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "d-block",
                      attrs: {
                        variant: "theme",
                        title: "Close View Popup",
                        size: "sm"
                      },
                      on: { click: _vm.closeVuewSelectModal }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "view-select-body" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeView != "-1",
                        expression: "activeView != '-1'"
                      }
                    ],
                    staticClass: "dropdown-item clear-view",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        _vm.handleResetFilter()
                        _vm.$bvModal.hide("headerViewSelectModal")
                      }
                    }
                  },
                  [
                    _vm._v("\n\t\t\t\t\tClear View\n\t\t\t\t\t"),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "fas fa-cross text-primary" })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewModalShowUpdateView,
                        expression: "viewModalShowUpdateView"
                      }
                    ],
                    staticClass: "dropdown-item update-view",
                    attrs: { href: "#" },
                    on: { click: _vm.modalUpdateView }
                  },
                  [
                    _vm._v("\n\t\t\t\t\tUpdate View\n\t\t\t\t\t"),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "far fa-edit text-primary" })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewModalShowCreateView,
                        expression: "viewModalShowCreateView"
                      }
                    ],
                    staticClass: "dropdown-item save-view",
                    attrs: { href: "#" },
                    on: { click: _vm.modalSaveView }
                  },
                  [
                    _vm._v("\n\t\t\t\t\tSave View\n\t\t\t\t\t"),
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", {
                        staticClass: "fas fa-plus-circle text-primary"
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.showNewViewTitleArea
                  ? _c(
                      "div",
                      { staticClass: "new-view-title-area" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("h5", [_vm._v("Save View")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ViewTitleModal", {
                          attrs: { hasCancelButton: true },
                          on: {
                            setActiveView: _vm.setActiveView,
                            cancelEdit: function($event) {
                              _vm.showNewViewTitleArea = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showUpdateViewTitleArea
                  ? _c(
                      "div",
                      { staticClass: "update-view-title-area" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("h5", [_vm._v("Update View")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("ViewTitleModal", {
                          attrs: {
                            title: _vm.viewBtnLabel,
                            viewId: _vm.activeView,
                            hasCancelButton: true
                          },
                          on: {
                            setActiveView: _vm.setActiveView,
                            cancelEdit: function($event) {
                              _vm.showUpdateViewTitleArea = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showNewViewTitleArea && !_vm.showUpdateViewTitleArea
                  ? _c(
                      "div",
                      { ref: "views__scroll", staticClass: "views__scroll" },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              scroll__view__btns:
                                !_vm.viewModalShowCreateView &&
                                !_vm.viewModalShowUpdateView
                            }
                          },
                          [
                            _vm._l(_vm.presetViewsProject, function(
                              userView,
                              index
                            ) {
                              return _c(
                                "a",
                                {
                                  key: "userView" + index + 1 * Math.random(),
                                  staticClass: "dropdown-item",
                                  class: {
                                    active: _vm.activeView == userView.id
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadViewFromModal(
                                        userView,
                                        index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "preset-icon-wrap"
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "save-title" }, [
                                    _vm._v(_vm._s(userView.title))
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.userViewsProject, function(
                              userView,
                              index
                            ) {
                              return _c(
                                "a",
                                {
                                  key: "userView" + index + 1 * Math.random(),
                                  staticClass: "dropdown-item",
                                  class: {
                                    active: _vm.activeView == userView.id
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.loadViewFromModal(
                                        userView,
                                        index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "remove-icon-wrap" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "remove-icon",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.removeView(userView.id)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-trash"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "save-title" }, [
                                    _vm._v(_vm._s(userView.title))
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "project__list" },
        [
          _c("div", { staticClass: "project-header" }, [
            _c("h2", { staticClass: "d-inline-block" }, [
              _c(
                "div",
                {
                  staticClass: "project-icon",
                  class: !_vm.userCanCreateProject ? "pointer-default" : "",
                  on: {
                    click: function($event) {
                      _vm.userCanCreateProject ? _vm.createNewProject() : ""
                    }
                  }
                },
                [
                  _c("img", { attrs: { src: "images/primary-folder.svg" } }),
                  _vm._v(" "),
                  _vm.userCanCreateProject
                    ? _c("span", { staticClass: "add-project-icon" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/csmworkflow/img/add-icon.svg")
                          }
                        })
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v("\n\t\t\tProjects\n\t\t\t"),
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  "(" +
                    _vm._s(_vm.allProjectsPaginationData.total || 0) +
                    " projects)"
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "d-inline-block float-right saved-views-area",
                class: [
                  !_vm.showUpdateViewText ? "pt-15" : "",
                  _vm.activeView != "-1" ? "saved-view-active" : ""
                ]
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showUpdateViewText,
                        expression: "showUpdateViewText"
                      }
                    ],
                    staticClass: "text-right"
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: { click: _vm.directUpdateView }
                      },
                      [_vm._v("Click here")]
                    ),
                    _vm._v(" to save updated view\n\t\t\t")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "btn-group float-right add-new__global_search sorting saved-views"
                  },
                  [
                    !_vm.showCreateNewView
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-theme ml-2 header-filter-btns dropdown-toggle",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            },
                            on: { click: _vm.updatePerfectScroll }
                          },
                          [
                            _vm.showUpdateViewText
                              ? _c("span", { staticClass: "updated-view" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "mr-3 view__label truncate-text" },
                              [_vm._v(_vm._s(_vm.viewBtnLabel))]
                            ),
                            _vm._v(" "),
                            _vm.activeView == "-1"
                              ? _c("i", {
                                  staticClass:
                                    "fas fa-fw fa-eye text-primary float-right"
                                })
                              : _c("i", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: {
                                        customClass: "save__view__tooltip"
                                      },
                                      expression:
                                        "{customClass: 'save__view__tooltip'}",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass:
                                    "fas fa-fw fa-eye text-primary float-right",
                                  attrs: { title: "Clear View" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleResetFilter()
                                    }
                                  }
                                })
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            }
                          },
                          [
                            _vm.showUpdateViewText
                              ? _c("span", { staticClass: "updated-view" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr-3 view__label" }, [
                              _vm._v("Views")
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: { customClass: "save__view__tooltip" },
                                  expression:
                                    "{ customClass: 'save__view__tooltip' }",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass:
                                "fas fa-fw fa-eye text-primary float-right",
                              attrs: { title: "Save View" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.saveView.apply(null, arguments)
                                }
                              }
                            })
                          ]
                        ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu viewmenu-dropdown" },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item update-view",
                                attrs: { href: "#" },
                                on: { click: _vm.updateView }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\tUpdate View\n\t\t\t\t\t\t\t"
                                ),
                                _vm._m(0)
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item save-view",
                                attrs: { href: "#" },
                                on: { click: _vm.saveView }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\tSave View\n\t\t\t\t\t\t\t"
                                ),
                                _vm._m(1)
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "perfect-scrollbar",
                              {
                                ref: "views__scroll",
                                staticClass: "views__scroll"
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _vm._l(_vm.presetViewsProject, function(
                                      userView,
                                      index
                                    ) {
                                      return _c(
                                        "a",
                                        {
                                          key:
                                            "userView" +
                                            index +
                                            1 * Math.random(),
                                          staticClass: "dropdown-item",
                                          class: {
                                            active:
                                              _vm.activeView == userView.id
                                          },
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.loadView(
                                                userView,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "preset-icon-wrap"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "save-title" },
                                            [_vm._v(_vm._s(userView.title))]
                                          )
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.userViewsProject, function(
                                      userView,
                                      index
                                    ) {
                                      return _c(
                                        "a",
                                        {
                                          key:
                                            "userView" +
                                            index +
                                            1 * Math.random(),
                                          staticClass: "dropdown-item",
                                          class: {
                                            active:
                                              _vm.activeView == userView.id
                                          },
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.loadView(
                                                userView,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "remove-icon-wrap" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "remove-icon",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.removeView(
                                                        userView.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fas fa-trash"
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "save-title" },
                                            [_vm._v(_vm._s(userView.title))]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "d-inline-block float-right project-sort",
                class: _vm.showUpdateViewText ? "pt-25" : "pt-15"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "add-new__global_search float-right btn-group header-filter-btns project-sort-button ml-2"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-theme header-filter-btns",
                        attrs: {
                          type: "button",
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "sort__label truncate-text" },
                          [_vm._v(_vm._s(_vm.projectSortLabel))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu sortmenu-dropdown" },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "perfect-scrollbar",
                              {
                                ref: "sort__scroll",
                                staticClass: "sort__scroll"
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(_vm.sortGroup, function(
                                    sortOption,
                                    index
                                  ) {
                                    return _c(
                                      "a",
                                      {
                                        key:
                                          "projectSort" +
                                          index +
                                          1 * Math.random(),
                                        staticClass: "dropdown-item",
                                        class: {
                                          active: sortOption.sorts.includes(
                                            _vm.projectSortId
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setSort(sortOption)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "preset-icon-wrap"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "sort-title" },
                                          [_vm._v(_vm._s(sortOption.title))]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-theme",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.reverseSort()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "float-right" }, [
                          _c("i", {
                            class: "fas text-primary " + _vm.projectSortIcon
                          })
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          !_vm.isSortByDepartment
            ? _vm._l(_vm.projects, function(project, index) {
                return _c(
                  "div",
                  {
                    key: "project-" + index,
                    class: _vm.getProjectClasses(project)
                  },
                  [
                    _c("div", { staticClass: "project--list--top--section" }, [
                      !_vm.isParentProjectOnHold(project)
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass:
                                "project--list--icon prj-new-tab cursor-pointer",
                              style: {
                                backgroundColor: _vm.getProjectColor(project)
                              },
                              attrs: { title: "Open in new tab" },
                              on: {
                                click: function($event) {
                                  return _vm.goToProjectNewTab(
                                    project.project_number
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "folder-icon",
                                attrs: {
                                  src: require("@/csmworkflow/img/white-folder.svg"),
                                  alt: "project icon"
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "ext-link-icon",
                                attrs: {
                                  src: require("@/csmworkflow/img/external-link-alt-solid.svg"),
                                  alt: "project icon"
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isParentProjectOnHold(project)
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass:
                                "project--list--icon on-hold-icon prj-new-tab cursor-pointer",
                              attrs: { title: "Open in new tab" },
                              on: {
                                click: function($event) {
                                  return _vm.goToProjectNewTab(
                                    project.project_number
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "on-hold-icon-img",
                                attrs: {
                                  src: require("@/csmworkflow/img/project-on-hold-icon.svg"),
                                  alt: "On Hold"
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "ext-link-icon",
                                attrs: {
                                  src: require("@/csmworkflow/img/external-link-alt-solid.svg"),
                                  alt: "project icon"
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "top--bar" }, [
                        _c(
                          "div",
                          {
                            staticClass: "sections",
                            class: {
                              "flex-7":
                                project.total_unread_messages_in_conversation >
                                0
                            }
                          },
                          [
                            _c("div", { staticClass: "top" }, [
                              _c("div", { staticClass: "data--item" }, [
                                _c("span", { staticClass: "text--label" }, [
                                  _vm._v("START")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "text--data text-uppercase" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          project.created_at,
                                          "DD MMM, YYYY"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "data--item",
                                  class: {
                                    "border-right-none":
                                      project.total_unread_messages_in_conversation >
                                      0
                                  }
                                },
                                [
                                  _c("span", { staticClass: "text--label" }, [
                                    _vm._v("DEADLINE")
                                  ]),
                                  _vm._v(" "),
                                  project.due_date
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text--data text-uppercase"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("moment")(
                                                project.due_date,
                                                "DD MMM, YYYY"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text--data text-uppercase"
                                        },
                                        [_vm._v("Not Set")]
                                      )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "bottom" }, [
                              _c(
                                "div",
                                { staticClass: "project--department--wrap" },
                                [
                                  _c("ProjectDepartments", {
                                    attrs: { deliverable: project }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "value--item" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "edit-d-title",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.goToProject(project)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(project.title) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.getSystemSetting("is_chat_enabled") &&
                        project.total_unread_messages_in_conversation > 0
                          ? _c("div", { staticClass: "sections" }, [
                              _vm._m(2, true),
                              _vm._v(" "),
                              _c("div", { staticClass: "value--item" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: " d-flex flex-row",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToProject(project)
                                      }
                                    }
                                  },
                                  [
                                    _c("ListMessageCounter", {
                                      attrs: { deliverable: project }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getSystemSetting("project__show_engagement_manager")
                          ? _c("div", { staticClass: "sections" }, [
                              _vm._m(3, true),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "value--item" },
                                [
                                  _c("ProjectListEngagementManager", {
                                    attrs: { project: project }
                                  }),
                                  _vm._v(" "),
                                  _c("ProjectEngagementManagerLock", {
                                    attrs: { project: project }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "sections" }, [
                          _vm.getSystemSetting("project__project_lead_label")
                            ? _c("div", { staticClass: "data--item" }, [
                                _c(
                                  "span",
                                  { staticClass: "text--label label-desktop" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.getSystemSetting(
                                            "project__project_lead_label"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "text--label label-mobile" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("textInitials")(
                                            _vm.getSystemSetting(
                                              "project__project_lead_label"
                                            )
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _c("div", { staticClass: "data--item" }, [
                                _c(
                                  "span",
                                  { staticClass: "text--label label-desktop" },
                                  [_vm._v("PROJECT LEAD")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "text--label label-mobile" },
                                  [_vm._v("PL")]
                                )
                              ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "value--item" },
                            [
                              _c("ProjectListProjectLeaders", {
                                attrs: { project: project }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "sections" }, [
                          _vm._m(4, true),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value--item",
                              staticStyle: {
                                width: "100%",
                                "padding-right": "10px"
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { "flex-basis": "100%" } },
                                _vm._l(
                                  _vm._.filter(project.customFields, {
                                    field_key: "project_status"
                                  }),
                                  function(field, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: field.id * Math.random(),
                                        staticClass:
                                          "info-item info-item__project-status"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "requisition-number-value"
                                          },
                                          [
                                            _c("ProjectCustomFields", {
                                              attrs: {
                                                deliverable: project,
                                                customField: field
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.showProjectCustomField(
                          project,
                          "requisition_number"
                        )
                          ? _c("div", { staticClass: "sections" }, [
                              _vm._m(5, true),
                              _vm._v(" "),
                              _c("div", { staticClass: "value--item" }, [
                                _c(
                                  "span",
                                  _vm._l(
                                    _vm._.filter(project.customFields, {
                                      field_key: "requisition_number"
                                    }),
                                    function(field, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: field.id * Math.random(),
                                          staticClass: "info-item"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "requisition-number-value"
                                            },
                                            [
                                              _c("ProjectCustomFields", {
                                                attrs: {
                                                  deliverable: project,
                                                  customField: field
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "sections" }, [
                          _vm._m(6, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "value--item" }, [
                            _c(
                              "span",
                              _vm._l(
                                _vm._.filter(project.customFields, {
                                  field_key: "budget"
                                }),
                                function(field, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: field.id * Math.random(),
                                      staticClass: "info-item"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "budget-value" },
                                        [
                                          _c("ProjectCustomFields", {
                                            attrs: {
                                              deliverable: project,
                                              customField: field
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isSortByDepartment
            ? _vm._l(_vm.grouppedProject, function(department, index) {
                return _c(
                  "div",
                  { key: "department-" + index },
                  [
                    department.title == null
                      ? _c(
                          "div",
                          { staticClass: "project-department-group-header" },
                          [_c("h2", [_vm._v("No Department")])]
                        )
                      : _c(
                          "div",
                          { staticClass: "project-department-group-header" },
                          [_c("h2", [_vm._v(_vm._s(department.title))])]
                        ),
                    _vm._v(" "),
                    _vm._l(department.projects, function(project, index) {
                      return _c(
                        "div",
                        {
                          key: "project-" + index,
                          class: _vm.getProjectClasses(project)
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "project--list--top--section" },
                            [
                              !_vm.isParentProjectOnHold(project)
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass:
                                        "project--list--icon prj-new-tab cursor-pointer",
                                      style: {
                                        backgroundColor: _vm.getProjectColor(
                                          project
                                        )
                                      },
                                      attrs: { title: "Open in new tab" },
                                      on: {
                                        click: function($event) {
                                          return _vm.goToProjectNewTab(
                                            project.project_number
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "folder-icon",
                                        attrs: {
                                          src: require("@/csmworkflow/img/white-folder.svg"),
                                          alt: "project icon"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass: "ext-link-icon",
                                        attrs: {
                                          src: require("@/csmworkflow/img/external-link-alt-solid.svg"),
                                          alt: "project icon"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isParentProjectOnHold(project)
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass:
                                        "project--list--icon on-hold-icon prj-new-tab cursor-pointer",
                                      attrs: { title: "Open in new tab" },
                                      on: {
                                        click: function($event) {
                                          return _vm.goToProjectNewTab(
                                            project.project_number
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "on-hold-icon-img",
                                        attrs: {
                                          src: require("@/csmworkflow/img/project-on-hold-icon.svg"),
                                          alt: "On Hold"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass: "ext-link-icon",
                                        attrs: {
                                          src: require("@/csmworkflow/img/external-link-alt-solid.svg"),
                                          alt: "project icon"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "top--bar" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "sections",
                                    class: {
                                      "flex-7":
                                        project.total_unread_messages_in_conversation >
                                        0
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "top" }, [
                                      _c("div", { staticClass: "data--item" }, [
                                        _c(
                                          "span",
                                          { staticClass: "text--label" },
                                          [_vm._v("START")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text--data text-uppercase"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("moment")(
                                                  project.created_at,
                                                  "DD MMM, YYYY"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "data--item",
                                          class: {
                                            "border-right-none":
                                              project.total_unread_messages_in_conversation >
                                              0
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text--label" },
                                            [_vm._v("DEADLINE")]
                                          ),
                                          _vm._v(" "),
                                          project.due_date
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--data text-uppercase"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("moment")(
                                                        project.due_date,
                                                        "DD MMM, YYYY"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--data text-uppercase"
                                                },
                                                [_vm._v("Not Set")]
                                              )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "bottom" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "project--department--wrap"
                                        },
                                        [
                                          _c("ProjectDepartments", {
                                            attrs: { deliverable: project }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "value--item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "edit-d-title",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.goToProject(
                                                    project
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(project.title) +
                                                  "\n\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                project.total_unread_messages_in_conversation >
                                0
                                  ? _c("div", { staticClass: "sections" }, [
                                      _vm._m(7, true),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "value--item" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-row",
                                              on: {
                                                click: function($event) {
                                                  return _vm.goToProject(
                                                    project
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("ListMessageCounter", {
                                                attrs: { deliverable: project }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.getSystemSetting(
                                  "project__show_engagement_manager"
                                )
                                  ? _c("div", { staticClass: "sections" }, [
                                      _vm._m(8, true),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "value--item" },
                                        [
                                          _c("ProjectListEngagementManager", {
                                            attrs: { project: project }
                                          }),
                                          _vm._v(" "),
                                          _c("ProjectEngagementManagerLock", {
                                            attrs: { project: project }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "sections" }, [
                                  _vm.getSystemSetting(
                                    "project__project_lead_label"
                                  )
                                    ? _c("div", { staticClass: "data--item" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text--label label-desktop"
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.getSystemSetting(
                                                    "project__project_lead_label"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text--label label-mobile"
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("textInitials")(
                                                    _vm.getSystemSetting(
                                                      "project__project_lead_label"
                                                    )
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ])
                                    : _c("div", { staticClass: "data--item" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text--label label-desktop"
                                          },
                                          [_vm._v("PROJECT LEAD")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text--label label-mobile"
                                          },
                                          [_vm._v("PL")]
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "value--item" },
                                    [
                                      _c("ProjectListProjectLeaders", {
                                        attrs: { project: project }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "sections" }, [
                                  _vm._m(9, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "value--item",
                                      staticStyle: {
                                        width: "100%",
                                        "padding-right": "10px"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "flex-basis": "100%" }
                                        },
                                        _vm._l(
                                          _vm._.filter(project.customFields, {
                                            field_key: "project_status"
                                          }),
                                          function(field, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: field.id * Math.random(),
                                                staticClass: "info-item"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "requisition-number-value"
                                                  },
                                                  [
                                                    _c("ProjectCustomFields", {
                                                      attrs: {
                                                        deliverable: project,
                                                        customField: field
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.showProjectCustomField(
                                  project,
                                  "requisition_number"
                                )
                                  ? _c("div", { staticClass: "sections" }, [
                                      _vm._m(10, true),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "value--item" },
                                        [
                                          _c(
                                            "span",
                                            _vm._l(
                                              _vm._.filter(
                                                project.customFields,
                                                {
                                                  field_key:
                                                    "requisition_number"
                                                }
                                              ),
                                              function(field, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      field.id * Math.random(),
                                                    staticClass: "info-item"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "requisition-number-value"
                                                      },
                                                      [
                                                        _c(
                                                          "ProjectCustomFields",
                                                          {
                                                            attrs: {
                                                              deliverable: project,
                                                              customField: field
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "sections" }, [
                                  _vm._m(11, true),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "value--item" }, [
                                    _c(
                                      "span",
                                      _vm._l(
                                        _vm._.filter(project.customFields, {
                                          field_key: "budget"
                                        }),
                                        function(field, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: field.id * Math.random(),
                                              staticClass: "info-item"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "budget-value" },
                                                [
                                                  _c("ProjectCustomFields", {
                                                    attrs: {
                                                      deliverable: project,
                                                      customField: field
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ])
                                ])
                              ])
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("pagination", {
                attrs: { data: _vm.allProjectsPaginationData, limit: 5 },
                on: { "pagination-change-page": _vm.onChangePage }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "far fa-edit text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "fas fa-plus-circle text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label label-desktop" }, [
        _vm._v("ENGAGEMENT MANAGER")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text--label label-mobile" }, [_vm._v("EM")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label" }, [_vm._v("STATUS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label label-desktop" }, [
        _vm._v("REQUISITION NUMBER")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text--label label-mobile" }, [
        _vm._v("REQUISITION #")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label" }, [_vm._v("BUDGET")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label label-desktop" }, [
        _vm._v("ENGAGEMENT MANAGER")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text--label label-mobile" }, [_vm._v("EM")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label" }, [_vm._v("STATUS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label label-desktop" }, [
        _vm._v("REQUISITION NUMBER")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text--label label-mobile" }, [
        _vm._v("REQUISITION #")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data--item" }, [
      _c("span", { staticClass: "text--label" }, [_vm._v("BUDGET")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }